<template>
    <div class="field" :class="fieldClasses">
        <label :for="id" :class="classes">
            <input
                :id="id"
                type="checkbox"
                :name="name"
                :value="value"
                :checked="state"
                :disabled="isDisabled"
                @change="onChange"
            />
            <span class="checkbox-indicator" />
            <span class="checkbox-label">
                <slot></slot>
            </span>
        </label>
        <p v-if="error" class="help is-danger" v-text="error" />
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'input'],

    props: {
        name: { type: String, default: null },
        position: { type: String, default: 'center' },
        value: { type: [String, Number], default: null },
        modelValue: { type: [String, Array], default: undefined },
        checked: { type: Boolean, default: false },
        error: { type: String, default: '' },
        model: {},
        wrapperClass: { type: String, default: '' },
        isDisabled: { type: Boolean, default: false },
    },

    data() {
        return {
            id: `checkbox-${Math.random().toString(36).substr(2, 9)}`,
        };
    },

    computed: {
        classes() {
            return {
                checkbox: true,
                'checkbox--top': this.position === 'top',
                'is-danger': this.error,
            };
        },

        state() {
            if (this.modelValue === undefined) {
                return this.checked;
            } else if (Array.isArray(this.modelValue)) {
                return this.modelValue.indexOf(this.value) > -1;
            } else {
                return !!this.modelValue;
            }
        },

        fieldClasses() {
            return this.wrapperClass;
        },
    },

    watch: {
        checked(val) {
            if (val !== this.state) {
                this.toggle();
            }
        },
    },

    methods: {
        onChange() {
            this.toggle();
        },

        toggle() {
            let value;

            if (Array.isArray(this.modelValue)) {
                value = this.modelValue.slice(0);

                if (this.state) {
                    value.splice(value.indexOf(this.value), 1);
                } else {
                    value.push(this.value);
                }
            } else {
                value = !this.state;
            }

            this.$emit('input', value);
            this.$emit('update:modelValue', value);
        },
    },

    mounted() {
        if (this.checked && !this.state) {
            this.toggle();
        }
    },
};
</script>
